import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useTranslation } from "react-i18next";
import { AuditRow } from "../../../models/AuditRow";
import { AUDIT_TOKENS } from "../../../theme/auditTokens";

interface Props extends GridRenderCellParams<AuditRow> {
  onShowMap: (row: AuditRow) => void;
}

export function MapButtonCell({ row, onShowMap }: Props) {
  const { t } = useTranslation();
  const label = row.rowType === "day" ? t("logbookAudit.map.showDay") : t("logbookAudit.map.showTrip");
  return (
    <Tooltip title={label}>
      <IconButton size="small" onClick={() => onShowMap(row)} aria-label={label} sx={{ color: AUDIT_TOKENS.accent }}>
        <MapOutlinedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
